import { gql } from "@apollo/client";

export const QUERY = gql`
  fragment MapLocationFields on LocationType {
    id
    company {
      id
      name
    }
    displayName
    location {
      coordinates
    }
    games {
      id
      isCompleted
      isScary
      primaryCategory {
        id
        slug
        parent {
          id
          slug
        }
      }
      status
      tags {
        id
      }
    }
  }

  query Games(
    $boundingBox: CoordinateBoundingBox
    $escapedOnly: Boolean
    $excludeNotPlayed: Boolean
    $excludePlayed: Boolean
    $excludeSaved: Boolean
    $filters: GameFiltersInput
    $groupByLocation: Boolean
    $includeAllGames: Boolean
    $lat: Float
    $lng: Float
    $page: Int
    $pageSize: Int
    $query: String
    $savedOnly: Boolean
    $userId: ID
    $userIds: [ID]
    $client: String
  ) {
    games(
      boundingBox: $boundingBox
      escapedOnly: $escapedOnly
      excludeNotPlayed: $excludeNotPlayed
      excludePlayed: $excludePlayed
      excludeSaved: $excludeSaved
      filters: $filters
      groupByLocation: $groupByLocation
      includeAllGames: $includeAllGames
      isMap: true
      lat: $lat
      lng: $lng
      page: $page
      pageSize: $pageSize
      query: $query
      savedOnly: $savedOnly
      userId: $userId
      userIds: $userIds
      client: $client
    ) {
      count
      page
      pages
      objects {
        ...MapLocationFields
      }
    }
  }
`;
